export const PORTAL_SWITCHER_REDIRECT_URL = '/myaccounts?next=academy';
const FORBIDDEN_STATUS = 403;
const WRONG_HUBLET_STATUS = 488;

/**
 * These two statuses mean "the portal id in the URL isn't one this user can
 * reach", as opposed to a request that genuinely failed — callers route them
 * into portal resolution rather than surfacing an error.
 */
const PORTAL_ACCESS_DENIED_STATUSES = [FORBIDDEN_STATUS, WRONG_HUBLET_STATUS];
export const isPortalAccessDenied = status => status !== undefined && PORTAL_ACCESS_DENIED_STATUSES.includes(status);